var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_10015437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Line",
    fill: "#050819"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.53 11.47-4-4a.75.75 0 0 0 -1.06 1.06l2.72 2.72h-14.19a.75.75 0 0 0 0 1.5h14.19l-2.72 2.72a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0 0-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 16.25a.76.76 0 0 0 -.75.75v2a1.25 1.25 0 0 1 -1.25 1.25h-8a1.25 1.25 0 0 1 -1.25-1.25v-14a1.25 1.25 0 0 1 1.25-1.25h8a1.25 1.25 0 0 1 1.25 1.25v2a.75.75 0 0 0 1.5 0v-2a2.75 2.75 0 0 0 -2.75-2.75h-8a2.75 2.75 0 0 0 -2.75 2.75v14a2.75 2.75 0 0 0 2.75 2.75h8a2.75 2.75 0 0 0 2.75-2.75v-2a.76.76 0 0 0 -.75-.75z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.250f91d837ec6ad2289e30f570ad5aed.svg";
export { ForwardRef as ReactComponent };